<script setup lang="ts">
const props = defineProps<{
  error: any
}>()

const { t } = useI18n()

const title = computed(() => {
  if (props.error?.statusCode === 401) {
    return t('not_authorized')
  }

  if (props.error?.statusCode === 404) {
    return t('page_not_found')
  }

  return t('something_went_wrong')
})

const description = computed(() => {
  if (props.error?.statusCode === 401) {
    return t('not_authorized_to_access_this_page')
  }

  if (props.error?.statusCode === 404) {
    return t('please_contact_a_system_administrator')
  }

  return t('an_error_has_occured')
})

const app = useAppConfig()
const handleError = () => clearError({ redirect: '/home' })
const retry = () => clearError()

// Show/hide demo stack trace
const showStackTrace = ref(true)
</script>

<template>
  <div class="pb-16">
    <BasePlaceholderPage
      :title="title"
      :subtitle="description"
      image-size="md"
      class="relative !items-end"
    >
      <template #image>
        <component
          :is="resolveComponentOrNative(app.tairo.error.logo.component)"
          v-if="app.tairo.error?.logo?.component"
          v-bind="app.tairo.error.logo.props"
        ></component>
      </template>

      <div class="mt-4">
        <div
          class="text-muted-400/20 dark:text-muted-400/10 absolute inset-x-0 top-1/3 -translate-y-1/2 text-[13rem] font-bold sm:text-[20rem]"
        >
          <span>{{ props.error?.statusCode }}</span>
        </div>
        <div
          class="mx-auto flex w-full max-w-md items-center justify-center gap-2"
        >
          <BaseButton
            shape="curved"
            class="mx-auto !h-12 w-full max-w-[220px] items-center gap-2"
            @click="handleError"
          >
            <Icon name="feather:arrow-left" class="size-5" />
            {{ $t('back_to_home') }}
          </BaseButton>
          
        </div>
        
      </div>
    </BasePlaceholderPage>

    
  </div>
</template>

<style>
.stack {
  @apply text-sm;
}
.stack.internal {
  @apply opacity-100 ps-4 text-xs;
}
</style>
